import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth, useUser } from "@clerk/react";
import { toast } from "sonner";
import { ArrowRight, Handshake, Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { errMsg, useApi } from "@/lib/api";

const TxLink = ({ lotId }) => {
  const api = useApi();
  const [txId, setTxId] = useState(null);
  useEffect(() => {
    api("get", `/transactions/by-lot/${lotId}`).then((r) => setTxId(r.data.id)).catch(() => {});
  }, [api, lotId]);
  if (!txId) return null;
  return (
    <Button asChild className="w-full h-12 rounded-full font-semibold" data-testid="lot-go-transaction-btn">
      <Link to={`/transacciones/${txId}`}>Ir a la transacción <ArrowRight className="w-4 h-4" /></Link>
    </Button>
  );
};

const Adjudicate = ({ lot }) => {
  const api = useApi();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try {
      const { data } = await api("post", `/lots/${lot.id}/adjudicate`);
      toast.success("Lote adjudicado. Programa ahora la Orden de Retiro.");
      navigate(`/transacciones/${data.id}`);
    } catch (e) {
      const msg = errMsg(e);
      toast.error(msg, msg.includes("Mis empresas") ? { action: { label: "Mis empresas", onClick: () => navigate("/mis-empresas") } } : undefined);
      setBusy(false);
    }
  };
  return (
    <Button onClick={go} disabled={busy} className="w-full h-12 rounded-full font-semibold" data-testid="lot-adjudicate-btn">
      <Handshake className="w-4 h-4" />{lot.mode === "donacion" ? "Solicitar retiro sin costo" : "Adjudicar compra"}
    </Button>
  );
};

export const DealBar = ({ lot }) => {
  const { isSignedIn } = useAuth();
  const { user } = useUser();
  const navigate = useNavigate();
  const isOwner = user?.id === lot.owner_id;

  if (lot.status !== "active") {
    return (
      <div className="space-y-3" data-testid="lot-reserved-banner">
        <p className="flex items-center gap-2 text-sm font-medium text-slate-700 bg-slate-100 rounded-xl p-3"><Lock className="w-4 h-4" />Lote adjudicado: en proceso de retiro y trazabilidad.</p>
        {isSignedIn && <TxLink lotId={lot.id} />}
      </div>
    );
  }
  if (lot.mode === "subasta" || isOwner) return null;
  if (!isSignedIn) return <Button onClick={() => navigate("/sign-in")} className="w-full h-12 rounded-full font-semibold" data-testid="lot-adjudicate-login-btn">Inicia sesión para adjudicar</Button>;
  return <Adjudicate lot={lot} />;
};
